import { create } from "zustand";
import { message } from "antd";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  moneyPages: [],
  moneyPagesCount: 0,
  moneyPage: {},
  isLoading: false,
  isMoneypageLoading: false,
  error: null,
};

export const useMoneyPageStore = create((set) => {
  const setMoneyPages = (partial) =>
    set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    addMoneyPage: async (payload, cb) => {
      try {
        setMoneyPages({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post("/add-money-page", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setMoneyPages({ isLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setMoneyPages({ isLoading: false, error: err });
      }
    },
    getMoneyPages: async (payload, cb) => {
      try {
        setMoneyPages({ isLoading: true, error: null });
        const res = await AdminApiCaller.Get("/get-money-pages", payload);
        if (res?.status === 200) {
          setMoneyPages({
            moneyPages: res.data.pages,
            moneyPagesCount: res.data.count,
            isLoading: false,
          });
        } else {
          setMoneyPages({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setMoneyPages({ isLoading: false, error: err });
      }
    },
    getMoneyPage: async (payload, cb) => {
      try {
        setMoneyPages({ isMoneypageLoading: true, error: null });
        const res = await AdminApiCaller.Get(`/get-money-page?id=${payload?.id}`);
        if (res?.status === 200) {
          setMoneyPages({ moneyPage: res.data.page, isMoneypageLoading: false });
        } else {
          setMoneyPages({ isMoneypageLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setMoneyPages({ isMoneypageLoading: false, error: err });
      }
    },
    updateMoneyPage: async (payload, cb) => {
      try {
        setMoneyPages({ isMoneypageLoading: true, error: null });
        const res = await AdminApiCaller.Put("/update-money-page", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setMoneyPages({ isMoneypageLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setMoneyPages({ isMoneypageLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
